import api from "../../../../../api";
export const requestGetPartRequestMessages = (props) => {

    let url = `/messages/from/part-offer`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestGetSellerActiveRequestsMessages = (props) => {

    let url = `/messages/seller/active-requests`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestGetSellerOtherMessages = (props) => {

    let url = `/messages/seller/other-messages/${props.limit}/${props.offset}`;


    return api.get(url);
};
export const requestSendMessage = (payload) => {
    return api.post(`/seller/messages`, payload);
};


